import type { QueryKey } from "@tanstack/react-query";
import { EntityType } from "@repo/types/enums";
import type { UserDTO } from "@repo/types/dtos";
import type { RecordId, UpdateEntityItem } from "@repo/types/ui/tables";
import type { UpdateDataViewEntityModel } from "../types/viewModels/dataViews";
import { useUserColumns } from "@repo/hooks/columns";
import { useUpdateDataViewEntities } from "../hooks/queries";
import NewUser from "./NewUser";
import { PageView } from "../components/common/PageView";
import { ViewUser } from "../components/users/ViewUser";

const Users = () => {
  const { mutateAsync: updateDataViewEntity } =
    useUpdateDataViewEntities<UserDTO>();

  const handleCellValueUpdated = async (
    updateItem: UpdateEntityItem<UserDTO>,
    queryKeys?: QueryKey[],
  ) => {
    const updateEntity: UpdateDataViewEntityModel<UserDTO> = {
      RecordId: updateItem.RecordId,
      ColumnId: updateItem.ColumnId,
      Value: updateItem.Value,
      EntityType: EntityType.User,
      invalidateQueryKeys: queryKeys,
    };

    return await updateDataViewEntity(updateEntity);
  };

  return (
    <PageView<UserDTO>
      entityType={EntityType.User}
      useColumns={useUserColumns}
      onCellValueUpdated={handleCellValueUpdated}
      renderRecord={(selectedUserId: RecordId) => (
        <ViewUser userId={selectedUserId} />
      )}
      renderNewRecord={() => <NewUser />}
    />
  );
};

export { Users };
